import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col bg-gray-100 antialiased" }
const _hoisted_2 = { class: "bg-sky pb-44" }
const _hoisted_3 = {
  key: 0,
  class: "py-10"
}
const _hoisted_4 = { class: "max-w-7xl 2xl:max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-0" }
const _hoisted_5 = { class: "text-3xl font-bold text-white capitalize" }
const _hoisted_6 = {
  key: 1,
  class: "h-28 mt-1"
}
const _hoisted_7 = {
  key: 0,
  class: "-mt-1"
}
const _hoisted_8 = { class: "max-w-7xl 2xl:max-w-screen-2xl mx-auto pb-12 px-4 sm:px-6 lg:px-8 xl:px-0" }
const _hoisted_9 = { class: "bg-sky" }
const _hoisted_10 = { class: "max-w-7xl 2xl:max-w-screen-2xl mx-auto py-6 px-4 sm:px-6 lg:flex md:items-center md:justify-between lg:px-8" }
const _hoisted_11 = { class: "flex flex-col lg:flex-row items-center lg:justify-center lg:space-x-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://janover.ventures/",
  class: "text-white hover:text-gray-500 text-sm"
}, " About Janover ", -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://janover.ventures/",
  class: "text-white hover:text-gray-500 text-sm"
}, " Suggestion box ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 lg:mt-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm text-white" }, "© 2023 Janover, Inc. All rights reserved.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout_nav = _resolveComponent("layout-nav")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_layout_nav),
      (!_ctx.hideHeader)
        ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.currentRouteName), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6))
    ]),
    _createElementVNode("main", {
      class: _normalizeClass(["mb-auto", { '-mt-44': !_ctx.hideHeader, '-mt-72': _ctx.hideHeader }])
    }, [
      (_ctx.hideHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_view)
      ])
    ], 2),
    _createElementVNode("footer", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("a", {
            href: _ctx.termsAndConditions,
            class: "text-white hover:text-gray-500 text-sm",
            target: "_blank"
          }, " Terms and conditions ", 8, _hoisted_13),
          _createElementVNode("a", {
            href: _ctx.privacyPolicy,
            target: "_blank",
            class: "text-white hover:text-gray-500 text-sm"
          }, " Privacy policy ", 8, _hoisted_14),
          _hoisted_15
        ]),
        _hoisted_16
      ])
    ])
  ]))
}